import useTranslation from "next-translate/useTranslation";
import { Flex, Text, Box } from "rebass/styled-components";
import Button from "../common/Button";
import Heading from "../common/ServiceIcon";
import { howToStepsStyles as styles } from "../../lib/styles/landingStyles";

interface FeatureHowToProps {
  title?: string;
  desc: string;
  prefix: string;
  width: string;
  isMobileViewport: boolean;
}

export function FeatureHowTo(props: FeatureHowToProps) {
  const { title, desc, prefix, width, isMobileViewport } = props;
  const flexVariant = isMobileViewport ? "flexMobile" : "flex";

  return (
    <Flex
      variant={flexVariant}
      sx={{ ...styles.feature[flexVariant], width: width }}
    >
      <Box>
        <Text as="p" sx={styles.feature.stepNumber}>
          {prefix}
        </Text>
      </Box>
      <Box sx={styles.feature.infoBox}>
        <Heading as="h4" sx={styles.feature.infoTitle}>
          {title}
        </Heading>
        <Text as="p" sx={styles.feature.infoDesc}>
          {desc}
        </Text>
      </Box>
    </Flex>
  );
}

interface Props {
  isMobileViewport: boolean;
  variant: string;
  numSteps: number;
  buttonTitle?: string;
  onSubmit?: () => void;
}

function HowToSteps(props: Props) {
  const { isMobileViewport, variant, numSteps, buttonTitle, onSubmit } = props;
  const { t } = useTranslation(variant);

  let info: { prefix: string; title: string; desc: string }[] = [];
  [...Array(numSteps)].map((_, i) =>
    info.push({
      prefix: (i + 1).toString(),
      title: `step${i + 1}Title`,
      desc: `step${i + 1}Desc`
    })
  );

  const mainBoxVariant =
    variant === "veterinaryCover" ? "mainBox" : "mainBoxDefault";
  const flexVariant =
    variant === "veterinaryCover" ? "mainFlex" : "mainFlexDefault";

  const widthStep = isMobileViewport ? "100%" : `${100 / numSteps}%`;
  const hrLeftRight = `calc((100vw - 200px)/${numSteps * 2} + 100px)`;
  const hrSx = { left: hrLeftRight, right: hrLeftRight };

  const linkStyles = { ...styles.hr, ...hrSx };

  return (
    <Box sx={styles[mainBoxVariant]}>
      <Text as="h2" sx={styles.title}>
        {t("howToTitle")}
      </Text>
      <Box position="relative">
        {!isMobileViewport && <Box as="hr" sx={linkStyles} />}
        <Flex sx={styles[flexVariant]}>
          {info.map((feat, index) => (
            <FeatureHowTo
              key={index}
              title={t(`${feat.title}`)}
              desc={t(`${feat.desc}`)}
              prefix={feat.prefix}
              width={widthStep}
              isMobileViewport={isMobileViewport}
            />
          ))}
        </Flex>
      </Box>
      {!!buttonTitle && !isMobileViewport && (
        <Box sx={styles.boxButton}>
          <Button variant="secondary" sx={styles.mainButton} onClick={onSubmit}>
            {buttonTitle}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default HowToSteps;
